import clsx from 'clsx';

import { setDurationDisplay } from '@atom/utilities/timeUtilities';

import classes from './workTemplateTaskDetail.module.css';

const TaskDuration = () => {
  return (
    <div className={clsx(classes.timeRowItem, classes.duration)}>
      <div className={classes.labelContainer}>
        <div className={classes.label}>Duration</div>
      </div>
      <div className={classes.dateDisplay}>{setDurationDisplay(0)}</div>
    </div>
  );
};

export default TaskDuration;
